/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./Input.css";

import * as React from "react";

import { InputProps, InputState, InputAttribs } from "./Input.types";

export default class Input extends React.Component<InputProps, InputState> {

   private inputRef: React.RefObject<HTMLInputElement>;
   private componentClassName: string;

   constructor(props: InputProps) {

      super(props);
      this.componentClassName = "tk-input" + (this.props.cssSuffix ? `-${this.props.cssSuffix}` : "");
      this.inputRef = React.createRef<HTMLInputElement>();
      this.state= { value: "" };

   }

   public static getDerivedStateFromProps(props: InputProps, state: InputState): any {
      if ((props && !state) || (props.value !== state.value)) {
         return { value: props.value }
      } else {
         return null;
      }
   }

   public focus() {
      this.inputRef.current?.focus();
   }

   public select() {
      this.inputRef.current?.select();
   }

   public render() {

      const attrs: InputAttribs = {}
      const hintLeft = this.props.hintPre ? <div className="hint-left">{this.props.hintPre}</div> : <></>;
      const hintRight = this.props.hintPost ? <div className="hint-right">{this.props.hintPost}</div> : <></>;
      const icons = this.props.icons ? <div className="icons">{this.props.icons}</div> : <></>;

      if (this.props.tooltipText) attrs["title"] = this.props.tooltipText;
      if (this.props.disabled) attrs["data-disabled"] = "true";
      if (this.props.valid !== undefined) attrs["data-valid"] = this.props.valid ? "true" : "false";

      return (

         <div className={this.componentClassName} {...attrs} onMouseDown={(ev: React.MouseEvent) => { this?.inputRef?.current?.focus() }}>

            <div className="container">

               {hintLeft}

               <input
                  ref={this.inputRef}
                  type={this.props.type || "text"}
                  id={this.props.id}
                  placeholder={this.props.placeholder}
                  min={this.props.min}
                  max={this.props.max}
                  step={this.props.step}
                  list={this.props.list}
                  value={this.state.value}
                  autoComplete={this.props.autoComplete}
                  readOnly={this.props.readOnly}
                  onChange={this.onChange}
                  onFocus={this.onFocus}
                  onBlur={this.onBlur}
                  onMouseDown={this.onMouseDown}
               />

               {icons}
               {hintRight}


            </div>

            <div className="validation-text-valid">
               {this.props.validText}&nbsp;
            </div>

            <div className="validation-text-invalid">
               {this.props.invalidText}&nbsp;
            </div>

         </div>

      )

   }

   private onChange = (ev: React.ChangeEvent) => {

      const el = ev.target as HTMLInputElement;
      const val: string | number = this.props.type === "number" ? el.value ? el.valueAsNumber : 0 : el.value ? el.value : "";

      this.setState({value: val });
      if (this.props.onChange) this.props.onChange(val);

   }

   private onFocus = (ev: React.FocusEvent) => {
      if (this.props.onFocus) this.props.onFocus(ev);
   }

   private onBlur = (ev: React.FocusEvent) => {
      if (this.props.onBlur) this.props.onBlur(ev);
   }

   private onMouseDown = (ev: React.MouseEvent) => {
      if (this.props.onMouseDown) this.props.onMouseDown(ev);
   }

}